import _ from 'underscore';
import queryString from 'query-string';

function findMismatches(original, expected) {
  return _.reduce(expected, (result, value, key) => {
    if (_.has(original, key) && !!value && original[key] !== `${value}`) {
      _.extend(result, { [key]: `${value}` });
    }
    return result;
  }, {});
}

// For fresh page load, in case user put wrong values for known query params (uid, cid, aid),
// this component restores it per server context
export function checkQueryParams(serverContext) {
  const query = queryString.parse(window.location.search);
  const {
    CurrentUser: { Id: uid },
    CurrentCustomer: { Id: cid },
    CurrentAccount: { Id: aid },
  } = serverContext;

  const mismatches = findMismatches(query, { uid, cid, aid });

  if (!_.isEmpty(mismatches)) {
    const updatedQuery = _.extend(query, mismatches);
    window.history.replaceState({}, document.title, `?${queryString.stringify(updatedQuery, { sort: false })}`);
  }
}
